import request from '@/utils/request'

// 课程相关接口

// 新增课程
export function courseCreate(params) {
	return request({
		url: '/discover/course/create',
		method: 'post',
		data: params
	})
}

// 编辑我的资源
export function courseUpdate(params) {
	return request({
		url: '/discover/course/update',
		method: 'post',
		data: params
	})
}

// 获取我的课程
export function userCource(params) {
	return request({
		url: '/discover/course/user/create',
		method: 'get',
		params: params
	})
}

// 课程详情
export function courseDetail(params) {
	return request({
		url: '/discover/course/detail',
		method: 'get',
		params: params,

	})
}

// 删除我的课程
export function courseDelete(params) {
	return request({
		url: '/discover/course/delete',
		method: 'get',
		params: params,

	})
}

// 全部课程
export function allCourse(params) {
	return request({
		url: '/discover/course/list',
		method: 'get',
		params: params,
	})
}

